module.exports = __webpack_public_path__ + "img/28_82.a37bb90d.png";